/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import Swiper from './../../node_modules/swiper/js/swiper';
import './../../node_modules/swiper/css/swiper.css'
import Item from './item';
import toleft from './../assets/images/tolefts.png';
import tolefts from './../assets/images/toleft.png';
import toright from './../assets/images/torights.png';
import torights from './../assets/images/toright.png';

const Recommend = props => {
  const [index, index_] = useState(-1);
  useEffect(() => {
    new Swiper('.swiper-container', {
      navigation: props.data.length >= 4 ? {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      } : {},
      simulateTouch: false,
      observe: true,
      slidesPerView: 4,
      observeParents: true,
      on: {
        slideChange() {
          if (this.activeIndex === 0) {
            index_(-1);
            return;
          }
          if (props.data.length - 4 === this.activeIndex) {
            index_(1);
          } else {
            index_(0);
          }
        },
      },
    })
  }, [props.data])

  const hover = (type, status) => {
    if (type === 1) {
      if (status === 1) {
        if (index === 1) return;
        nextImg_(torights);
      } else {
        nextImg_(toright);
      }
    } else {
      if (status === 1) {
        if (index === -1) return;
        prevImg_(tolefts);
      } else {
        prevImg_(toleft);
      }
    }
  }

  const [prevImg, prevImg_] = useState(toleft);
  const [nextImg, nextImg_] = useState(toright);

  return (
    <React.Fragment>
      <div className = 'listBox-inner'>
        <div className = "swiper-container">
          <div className = "swiper-wrapper">
            {
              props.data.map(item => (
                <div
                  key = {item.vid}
                  className = "swiper-slide"
                  onClick = {() => {
                    window.report({
                      eid: 'click/livecoursevideo/recommend',
                      eid_desc: '点击/开播教程视频专题/推荐视频',
                    });
                  }}
                >
                  <Item {...item}/>
                </div>
              ))
            }
          </div>
        </div>
      </div>
      {
        props.data.length > 4 &&
        <React.Fragment>
          <div
            className = {
              'swiper-button-prev'
            }
            style = {
              {backgroundImage: `url(${prevImg})`}
            }
            onMouseOver = {
              () => {
                hover(0, 1)
              }
            }
            onMouseOut = {
              () => {
                hover(0, 0)
              }
            }
          ></div>
          <div
            className = {
              'swiper-button-next'
            }
            style = {
              {backgroundImage: `url(${nextImg})`}
            }
            onMouseOver = {
              () => {
                hover(1, 1)
              }
            }
            onMouseOut = {
              () => {
                hover(1, 0)
              }
            }
          ></div>
        </React.Fragment>
      }
    </React.Fragment>
  );
}

export default Recommend;
